import React from 'react';
import styles from './UIGamePlayerInfoHeader.module.scss';
import { UIGamePlayerInfoHeaderPointsPublic } from './UIGamePlayerInfoHeaderPointsPublic/UIGamePlayerInfoHeaderPointsPublic.tsx';
import clsx from 'clsx';
import { UIGamePlayerInfoHeaderPointsPrivate } from './UIGamePlayerInfoHeaderPointsPrivate/UIGamePlayerInfoHeaderPointsPrivate.tsx';
import { getColorFromPlayerColor, shouldUseBlackTextForPlayerColor } from '../../UIGamePlayerInfoContainer/UIGamePlayerInfoContainerUtils.ts';
export const UIGamePlayerInfoHeader = ({ playerColor, avatar, username, pointsPublic, pointsPrivate })=>{
    const color = getColorFromPlayerColor(playerColor);
    const shouldUseBlackText = shouldUseBlackTextForPlayerColor(playerColor);
    const isPrivatePointsVisible = pointsPrivate !== undefined && pointsPrivate > 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.wrapper, {
            [styles.blackText]: shouldUseBlackText
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.pointsPublicContainer
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoHeaderPointsPublic, {
        points: pointsPublic,
        playerColor: playerColor
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.container,
        style: {
            '--player-color': color
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.background
    }), isPrivatePointsVisible ? /*#__PURE__*/ React.createElement("div", {
        className: styles.pointsPublicAndPrivateBuffer
    }) : /*#__PURE__*/ React.createElement("div", {
        className: styles.pointsPublicBuffer
    }), isPrivatePointsVisible && /*#__PURE__*/ React.createElement("div", {
        className: styles.pointsPrivateContainer
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoHeaderPointsPrivate, {
        points: pointsPublic + pointsPrivate,
        playerColor: playerColor
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.avatarContainer
    }, /*#__PURE__*/ React.createElement("img", {
        src: avatar,
        className: styles.avatar
    })), /*#__PURE__*/ React.createElement("span", {
        className: clsx(styles.username, {
            [styles.usernameWithPrivatePoints]: isPrivatePointsVisible
        })
    }, username)));
};
